export const PASSWORD_CONNECTION = 'Username-Password-Authentication';

export enum Columns {
  Domain = 'domain',
  SsoName = 'ssoName',
  SsoStatus = 'ssoStatus',
  SsoService = 'ssoService',
  SsoRegistration = 'ssoRegistration',
  Actions = 'actions',
}

/** Configuration options for generating a random string */
export interface RandomStringConstraints {
  /** The desired length of the random string */
  length: number;
  /** An array specifying which character types to include in the random string */
  includes: Array<'lowercase' | 'uppercase' | 'digits'>;
}
